import _ from 'lodash';
import {
  required, numeric, maxLength, minLength, minValue,
} from 'vuelidate/lib/validators';
import ToolKitMixin from '@/app/mixins/toolkit/item';
import RatifyQuestion from './ratify-question/ratify-question.vue';

export default {
  name: 'member-selection',
  mixins: [ToolKitMixin],
  components: {
    RatifyQuestion,
  },
  data: () => ({
    memberSelection: [],
  }),
  methods: {
    handleNextStep() {
      this.$emit('nextStep');
    },
    handleRatify(ratify) {
      this.ratify = ratify;
    },
  },
  computed: {
    members() {
      const { members } = this.$store.getters['fund/getFund'];
      return members.map(member => ({
        ...member,
        value: `${member.firstName} ${member.lastName}`,
      }));
    },
    finYear: {
      get() {
        return this.getItem.finYear;
      },
      set(value) {
        this.setItem({ finYear: value });
      },
    },
    ratify: {
      get() {
        return this.getItem.ratify;
      },
      set(value) {
        this.setItem({ ratify: value });
      },
    },
  },
  watch: {
    memberSelection(value) {
      const newSelection = value.map(val => this.members.find(member => member.value === val));
      const { members } = this.getItem;
      const newMembers = {};
      newSelection.forEach((member) => {
        newMembers[member.uuid] = {
          uuid: member.uuid,
          name: member.value,
          accounts: {},
          ...members[member.uuid],
        };
      });
      if (!_.isEqual(members, newMembers)) {
        this.setItem({ members: newMembers, rules: [], replace: true });
      } else {
        this.setItem({ members: newMembers, replace: true });
      }
    },
  },
  activated() {
    const { members } = this.getItem;
    this.memberSelection = [];
    Object.keys(members).forEach((key) => {
      this.memberSelection.push(members[key].name);
    });
  },
  validations: {
    finYear: {
      required,
      numeric,
      minLength: minLength(4),
      minValue: minValue(1900),
    },
    ratify: {
      required,
    },
    memberSelection: {
      required,
      maxLength: maxLength(2),
    },
  },
};
